<section class="banner-wave">

    <div class="container-fluid mt-6 banner-img pb-5">
        <div class=" ">
        </div>
        <div class="container  mt-5 pt-5">
            <div class="row g-5">
                <div class="col-md-6 d-flex text-center text-md-start align-items-center">
                    <div>
                        <h1 class="fw-bolder text-white font-56">Innovate, Engage, Transform Your Idea With Mobile App
                            Development Services </h1>
                        <p class="my-4  text-white text-wrap f-20 justify-text">Elevate your business with our wide
                            range of mobile App development services. Enhance your mobile reach and user experience,
                            engage your target audience with our functional and compelling apps for iOS and Android.
                        </p>
                        <button class=" bg-white px-5 rounded-0 border-0 shadow-lg fw-bold hover-effect py-2 brand-primary-text-color"
                                (click)="openModal()">View Demo <i
                            class="ms-3 fa-solid fa-arrow-right"></i>
                        </button>
                        <ng-template #contactFormModal>
                            <app-contact-form [isModalOpen]="isModalOpen"
                                              (closeModal)="closeModal()"></app-contact-form>
                        </ng-template>
                        <div *ngIf="isModalOpen" class="modal-overlay" (click)="handleOverlayClick($event)">
                            <ng-container *ngTemplateOutlet="contactFormModal"></ng-container>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 d-flex justify-content-end py-5 d-flex justify-content-center">
                    <div
                        class="  md:mr-0 position-relative h-100 w-100 border-0 d-flex justify-content-center border-radius-10">
                        <img src="assets/img/landing-new/mobile-development/mobile-app.png" alt="Image"
                             class="img-fluid border-radius-10"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="container-fluid banner-img-2">
    <div class="container py-5">
        <div class="row">
            <div class="col-12 ps-md-5 py-md-5 py-4 text-center">
                <h2 class=" fs-1 fw-bolder">About Volmint’s
                    <span class="brand-primary-text-color"> Mobile App Development Services</span></h2>
                <p class=" text-secondary text-wrap justify-text">At Volmint Technologies, we specialize in building
                    robust, scalable, and user-friendly applications tailored to your unique business needs. With
                    expertise spanning diverse industries, we combine creativity and innovation to deliver apps that
                    drive results.
                </p>
                <p class="  text-secondary text-wrap justify-text">As one of the best-known top mobile application
                    development company, we offer more than just smartphone services. Our portfolios of app development
                    for android and app development for iOS demonstrate our proficiency with a range of devices and
                    platforms.

                </p>
                <p class=" text-secondary text-wrap justify-text">We focus on quality, functionality, and
                    performance from consultation to deployment. Our customer-first approach ensures seamless
                    integration, superior UI/UX, and comprehensive support. Whether you’re a startup or an established
                    enterprise, we’re here to transform your ideas into impactful mobile solutions. Let’s create apps
                    that not only meet your goals but exceed expectations.
                </p>
            </div>
        </div>
        <div class="row mt-md-5 ">
            <h2 class=" fs-1 fw-bolder text-center mb-4">Our Comprehensive Services for Every Business Need
                <span class="brand-primary-text-color">Every Business Need</span></h2>

            <div class="col-md-6">
                <div class="blog-card ">
                    <div class="meta">
                        <div class="photo"
                             style="background-image: url(assets/img/landing-new/mobile-development/android-ios.png)"></div>
                        <ul class="details">
                        </ul>
                    </div>
                    <div class="description">
                        <h3 class="fw-bold fs-4 brand-primary-text-color">Android and iOS App Development
                            Consultation </h3>
                        <p class="text-secondary"> Mobile apps have their own user base and expectations from consumers. We help you refine
                            your app ideas with in-depth consultation, offering strategic guidance and feasibility
                            analysis to ensure your app aligns perfectly with your services.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="blog-card alt ">
                    <div class="meta">
                        <div class="photo"
                             style="background-image: url(/assets/img/landing-new/mobile-development/UIUX-Design.png);"></div>
                        <ul class="details">
                        </ul>
                    </div>
                    <div class="description">
                        <h3 class="fw-bold fs-4 brand-primary-text-color">UI/UX Design</h3>
                        <p class="text-secondary">Mobile Applications are one of the most accessible and adaptable ecosystems with a variety of
                            devices within it. Our expert designers craft intuitive and engaging interfaces, ensuring
                            your app delivers seamless user experiences and keeps your audience coming back for more.
                        </p>

                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="blog-card ">
                    <div class="meta">
                        <div class="photo"
                             style="background-image: url(https://storage.googleapis.com/chydlx/codepen/blog-cards/image-1.jpg)"></div>
                        <ul class="details">
                        </ul>
                    </div>
                    <div class="description">
                        <h3 class="fw-bold fs-4 brand-primary-text-color">Android and iOS Software Testing</h3>
                        <p class="text-secondary"> We are using a procedure designed to prioritize security and performance. We blend manual
                            and automated testing processes to ensure your app performs glitch or bugs-free, secure and
                            delivers an optimal experience across all tech devices.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="blog-card alt ">
                    <div class="meta">
                        <div class="photo"
                             style="background-image: url(https://storage.googleapis.com/chydlx/codepen/blog-cards/image-2.jpg)"></div>
                        <ul class="details">
                        </ul>
                    </div>
                    <div class="description">
                        <h3 class="fw-bold fs-4 brand-primary-text-color">Custom Application Development</h3>
                        <p class="text-secondary">Our developers are experts in building reliable, scalable Android app development solutions.
                            We develop tailored apps with innovative features and functionalities that cater to your
                            specific business needs, ensuring a unique digital presence.
                        </p>

                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="blog-card ">
                    <div class="meta">
                        <div class="photo"
                             style="background-image: url(https://storage.googleapis.com/chydlx/codepen/blog-cards/image-1.jpg)"></div>
                        <ul class="details">
                        </ul>
                    </div>
                    <div class="description">
                        <h3 class="fw-bold fs-4 brand-primary-text-color">Multi-Platform Deployment </h3>
                        <p class="text-secondary"> We are a leading custom app development company with a focus on development and smooth
                            integration. We deploy your app across various platforms, ensuring maximum reach and
                            compatibility to connect with a broader audience seamlessly..
                        </p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<!--<div class="container-fluid bottom-svg py-5">
    <div class="container pt-3">
        <div class="row">
            <div class="col-12 col-md-5 row pe-0">
                <img src="assets/img/landing-new/mobile-development/collage-mobile-development.png"
                     class="img-fluid w-75" alt="">

            </div>
        </div>
    </div>
</div>-->
<div class="container-fluid bg-purple ">
    <div class="container py-5">
        <h2 class="brand-primary-text-color text-center mt-5 fw-bold justify-text">Why Choose Volmint’s Mobile App
            Development Services?</h2>
        <p class="text-secondary text-center">At Volmint Technologies, our mobile applications are distinguished by their
            exceptional quality, innovative features, and unwavering commitment to excellence. We focus on user-centric
            design, creating intuitive interfaces that ensure an engaging and seamless experience. Our apps are
            optimized for performance, delivering rapid response times and reliability across both iOS and Android
            platforms. We prioritize security with robust measures to safeguard user data, and our scalable architecture
            allows for easy integration of future enhancements. With a dedication to leveraging the latest technologies
            and providing ongoing support, we empower businesses to excel in a dynamic marketplace. Choose our mobile
            applications for a transformative experience that propels your brand forward.
        </p>
        <div class="row gy-5 py-5">
            <div class="col-md-4" *ngFor="let item of whyChoose; let i = index">
                <div class="h-w-40 text-center rounded-circle bg-white pt-2 fw-bold text-black ">{{ i + 1 }}</div>
                <h3 class="brand-primary-text-color my-4 fw-bold">{{ item.header }}</h3>
                <p class="text-secondary justify-text">{{
                        item.text
                    }}</p>
            </div>
        </div>
    </div>
</div>



<div class="container-fluid py-5">
    <div class="container">
        <div class="row py-5 gx-5">
            <h2 class="text-center fs-1 fw-bolder">How Volmint Transforms Businesses with Tailored
                <span class="brand-primary-text-color"> Mobile App Development Services</span>
            </h2>
            <div class="vertical-tabs my-5 mx-auto my col-12 row">
                <div class="tab-titles col-md-4">
                    <button class="my-1" *ngFor="let tab of tabs; let i = index"
                            [class.active]="i === selectedIndex"
                            (click)="selectTab(i)">
                        {{ tab.title }}
                    </button>
                </div>
                <div class="tab-content  border-start col-md-8">
                    <p class="text-secondary">{{ tabs[selectedIndex].content }}</p>
                </div>
            </div>
            <h2 class=" mx-aut my-5 text-center fs-1 fw-bolder">Brands We Have Worked For
            </h2>
            Use our previous work SS

        </div>

    </div>
</div>

<div class="container-fluid px-0 technology-bg ">
    <div class="container-fluid py-5"
         style="background: rgba(74, 68, 147, 0.75);">
        <div class="container">
            <h2 class=" fs-1 text-white fw-bolder"> Technologies We Use For
                <span class=""> Mobile App Development Services</span>

            </h2>
            <p class=" fs-6 text-white text-wrap justify-text">Volmint Technologies is known for its customer
                satisfaction with high-quality solutions to cater to their unique business needs. We designed highly
                performing and scalable apps with a focus on UX and UI. The technologies we use are:.</p>

            <div class="row g-4">
                <div class="p-3 col-12 col-md-4">
                    <div class=" bg-white px-2 py-3 h-100 text-center">
                        <div class="rounded-circle shadow d-flex align-items-center justify-content-center   mx-auto" style="width: 130px ; height:130px ">
                            <img src="assets/img/landing-new/mobile-development/technology/flutter.png" alt=""
                                 class=" w-75 img-fluid">
                        </div>
                        <h3 class="my-3 brand-primary-text-color fw-bold fs-5">Flutter</h3>
                        <p>Flutter mobile app development is an open-source software development kit. It allows the
                            developers to build apps for both Android and iOS using a single codebase, uses Google Dart
                            programming language. </p>
                    </div>
                </div>
                <div class="p-3 col-12 col-md-4">
                    <div class=" bg-white px-2 py-3 h-100 text-center">
                        <div class="rounded-circle shadow d-flex align-items-center justify-content-center   mx-auto" style="width: 130px ; height:130px ">
                            <img src="assets/img/landing-new/mobile-development/technology/java.png" alt=""
                                 class=" w-75 img-fluid">
                        </div>
                        <h3 class="my-3 brand-primary-text-color fw-bold fs-5">JAVA</h3>
                        <p>Alongside languages like Kotlin, BASIC, and C++, Java is a very dependable and popular programming language, particularly for making Android apps. </p>
                    </div>
                </div>
                <div class="p-3 col-12 col-md-4">
                    <div class=" bg-white px-2 py-3 h-100 text-center">
                        <div class="rounded-circle shadow d-flex align-items-center justify-content-center   mx-auto" style="width: 130px ; height:130px ">
                            <img src="assets/img/landing-new/mobile-development/technology/pusher.png" alt=""
                                 class=" w-100 img-fluid">
                        </div>
                        <h3 class="my-3 brand-primary-text-color fw-bold fs-5">Pusher</h3>
                        <p> Pusher is one of the most preferred tools for real-time Communication/socket programming. It helps to manage complex messaging infrastructure to build real-time features as per the user's needs. </p>
                    </div>
                </div>
                <div class="p-3 col-12 col-md-4">
                    <div class=" bg-white px-2 py-3 h-100 text-center">
                        <div class="rounded-circle shadow d-flex align-items-center justify-content-center   mx-auto" style="width: 130px ; height:130px ">
                            <img src="assets/img/landing-new/mobile-development/technology/web-rtc.png" alt=""
                                 class=" w-75 img-fluid">
                        </div>
                        <h3 class="my-3 brand-primary-text-color fw-bold fs-5">WEbRTC</h3>
                        <p>An open-source project called WebRTC (Web Real-Time Communications) makes it possible for web browsers and devices to communicate in real time via text, voice, and video. </p>
                    </div>
                </div>

                <div class="p-3 col-12 col-md-4">
                    <div class=" bg-white px-2 py-3 h-100 text-center">
                        <div class="rounded-circle shadow d-flex align-items-center justify-content-center   mx-auto" style="width: 130px ; height:130px ">
                            <img src="assets/img/landing-new/mobile-development/technology/firebase-setting.png" alt=""
                                 class=" w-100 img-fluid">
                        </div>
                        <h3 class="my-3 brand-primary-text-color fw-bold fs-5">Firebase Crashlytics</h3>
                        <p>By intelligently classifying crashes and emphasizing the conditions that precede them, Crashlytics helps you save time when debugging.</p>
                    </div>
                </div>
                <div class="p-3 col-12 col-md-4">
                    <div class=" bg-white px-2 py-3 h-100 text-center">
                        <div class="rounded-circle shadow d-flex align-items-center justify-content-center   mx-auto" style="width: 130px ; height:130px ">
                            <img src="assets/img/landing-new/mobile-development/technology/firebase-msging.png" alt=""
                                 class=" w-100 img-fluid">
                        </div>
                        <h3 class="my-3 brand-primary-text-color fw-bold fs-5">Firebase Cloud Messaging</h3>
                        <p>Firebase Cloud Messaging (FCM) offers the convenience of delivering and receiving messages and notifications on iOS and Android-like platforms. Works as a bridge between server and devices. </p>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>


<div class="container-fluid my-4 py-4">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="col-12">
                    <img src="assets/img/landing-new/mobile-development/faq.png" alt="Image" class="img-fluid w-50"/>
                    <h2 class="fs-1 fw-bold">Frequently Asked Questions</h2>
                    <p class="text-secondary">Have a question that is not answered? You can contact us at</p>
                    <p class="brand-primary-text-color fw-bold">Email: <a href="mailto:support@volmint.com"
                                                                          class="text-decoration-underline brand-primary-text-color">support@volmint.com</a>
                    </p>
                    <button type="submit"
                            class="brand-primary-bg border-0 color-white px-5 py-2 fs-6 mt-4 fw-bold hover-effect"
                            (click)="goTo('/faq')">
                        View All Faqs
                    </button>
                </div>
            </div>
            <div class="col-12 col-md-6 mt-4">
                <div class="accordion" id="faqAccordion">
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    <span class="fs-6 fw-bold brand-primary-text-color">
                        <div class="encircled-icon">
                            <i class="fas fa-question fw-bold"></i>
                        </div>
                        &nbsp;How much time does it take to make a mobile application?
                    </span>
                            </button>
                        </h3>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                It could take 2 to 12 months to develop a mobile application. The complexity of the project, the features included, the tools and technology stack utilized, the hourly rates, and the location of the Android app developers all affect how long it takes to create an Android app.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    <span class="fs-6 fw-bold brand-primary-text-color">
                        <div class="encircled-icon">
                            <i class="fas fa-question fw-bold"></i>
                        </div>
                        &nbsp;What is the mobile application development cost in India?
                    </span>
                            </button>
                        </h3>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                The price for developing an iOS or Android mobile application development cost varies on several factors such as features, technology stack, team size, and location of the application. To know more about the charges, get in touch with Volmint Technologies.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    <span class="fs-6 fw-bold brand-primary-text-color">
                        <div class="encircled-icon">
                            <i class="fas fa-question fw-bold"></i>
                        </div>
                        &nbsp;Is Volmint involved in getting the mobile app into the Play Store?
                    </span>
                            </button>
                        </h3>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Uploading a program to the Play Store is entirely our obligation as a top mobile application development company. It is a component of our all-inclusive solutions for Android app development.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                    <span class="fs-6 fw-bold brand-primary-text-color">
                        <div class="encircled-icon">
                            <i class="fas fa-question fw-bold"></i>
                        </div>
                        &nbsp;Will my project receive support and maintenance after it launches?
                    </span>
                            </button>
                        </h3>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Of course! Being a leading mobile application development company, we offer our clients thorough post-launch app support and maintenance. This covers several topics, speak with our professionals to learn more.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item shadow-lg border-0">
                        <h3 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                    <span class="fs-6 fw-bold brand-primary-text-color">
                        <div class="encircled-icon">
                            <i class="fas fa-question fw-bold"></i>
                        </div>
                        &nbsp;Why choose Volmint’s mobile app development services?
                    </span>
                            </button>
                        </h3>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                             data-bs-parent="#faqAccordion">
                            <div class="accordion-body fs-6 text-secondary justify-text">
                                Volmint Technologies is one of the most trusted IT providers, known for its robust business solutions and customer satisfaction. We create a personalized solution with deep marketing research, a customer-centric approach, flexible hiring modules, agile methodology, post-launch, and support maintenance.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid ums-bottom-bg ps-5 mt-5">
    <div class="container">
        <div class="row align-items-center py-5">
            <div class="col-md-10 col-12">
                <h1 class="text-white">Ready to Take Your Business Growth to the Next Level?</h1>
            </div>
            <div class="col-md-2 col-12">
                <button class="brand-primary-text-color bg-white border-0 rounded-0 px-5 py-3 fw-bold hover-effect"
                        (click)="goTo('/contact')">Contact Us
                </button>
            </div>
        </div>
    </div>
</div>
